import * as yup from 'yup';

import { YUP_OLD_EMAIL_REGEX } from '@clearverify/constants';

import { passwordValidationSchema } from 'src/constants/validation';

import { SignInFormField, VerificationCodeFormField } from '../types';

export const signInFormValidationSchema = yup.object({
  [SignInFormField.email]: yup
    .string()
    .matches(YUP_OLD_EMAIL_REGEX, 'Format is incorrect')
    .required(),
  [SignInFormField.password]: passwordValidationSchema,
});

export const verificationCodeFormValidationSchema = yup.object({
  [VerificationCodeFormField.verificationCode]: yup
    .string()
    .length(6, 'Must be 6 characters long')
    .required('Required'),
});
